export default {
  _handleLocationError(browserHasGeolocation) {
    return browserHasGeolocation
      ? "Error: The Geolocation service failed. Please turn on geolocation in browser."
      : "Error: Your browser doesn't support geolocation."
  },

  async getCurrentLocation() {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            resolve(position)
          },
          () => {
            console.log(this._handleLocationError(true))
            resolve(null)
          }
        );
      } else {
        console.log(this._handleLocationError(false))
        resolve(null)
      }
    })
  }
}
